import {Box, Button, Chip, Grid, Typography, useMediaQuery, useTheme} from "@material-ui/core";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import InfoIcon from "@material-ui/icons/Info";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import SchoolIcon from "@material-ui/icons/School";
import authApi from "api/authApi";
import {useAppSelector} from "app/hooks";
import NO_AVATAR from "assets/img/logo.png";
import MEDAL_GIOI from "assets/img/medal_gioi.png";
import MEDAL_KHA from "assets/img/medal_kha.png";
import MEDAL_THUKHOA from "assets/img/medal_thukhoa.png";
import MEDAL_TB from "assets/img/medal_tb.png";
import RadialSeparators from "components/RadialSeparators";
import {selectInfoLogin} from "features/Auth/authSlice";
import {StatisticHomePage} from "models/auth";
import React, {useEffect, useState} from "react";
import {buildStyles, CircularProgressbarWithChildren} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import {useNavigate} from "react-router-dom";
import ChartRanking from "./components/chartRanking";
import Statistics from "./components/statistics";
import TableCalendar from "./components/tableCalendar";
import useStyles from "./style";
import {useTranslation} from "react-i18next";

export default function HomePage() {
  const {t} = useTranslation();
  const classes = useStyles();
  const infoLogin = useAppSelector(selectInfoLogin);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints?.down("sm"));
  const [statistic, setStatistic] = useState<StatisticHomePage>();

  useEffect(() => {
    (async () => {
      try {
        const res: StatisticHomePage = await authApi.getStatisticHomePage();
        if (res.responseCode === "00") {
          setStatistic(res);
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const helloText = () => {
    const timer = new Date().getHours();
    if (timer > 18) {
      return `${t("home.chaobuoitoi")}`;
    } else if (timer <= 18 && timer > 15) {
      return `${t("home.chaobuoichieu")}`;
    } else if (timer <= 15 && timer > 11) {
      return `${t("home.chaobuoitrua")}`;
    } else {
      return `${t("home.chaobuoisang")}`;
    }
  };

  return (
    <Box className={classes.container}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} lg={4} style={{ display: "flex", flexDirection: "column" }}>
          <Box className={classes.content_info}>
            <Box className={classes.welcomeGlowTop} />
            <Box className={classes.welcomeGlowBottom} />

            <Box style={{ position: "relative", zIndex: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
              {/* Header Title & Greeting Pill */}
              <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12, marginBottom: 16 }}>
                <Box>
                  <Typography className={classes.welcomeSubtitle}>
                    {t("home.mungbanden")}
                  </Typography>
                  <Typography className={classes.welcomeTitle}>
                    GPET EDU
                  </Typography>
                </Box>
                <Box className={classes.greetingBadge}>
                  <span>👋 {helloText()}</span>
                </Box>
              </Box>

              {/* Middle Section: Avatar + User Info + Medal */}
              <Box style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 16 }}>
                <Box className={classes.avatarWrapper}>
                  {infoLogin?.profileImageUrl ? (
                    <img src={infoLogin?.profileImageUrl} alt="AVATAR" className={classes.avatarImage} />
                  ) : (
                    <img src={NO_AVATAR} alt="NO_AVATAR" className={classes.avatarImage} />
                  )}
                  <Box className={classes.onlineStatusDot} />
                </Box>

                <Box style={{ flexGrow: 1, minWidth: 0 }}>
                  <Typography className={classes.userNameText}>
                    {infoLogin?.name}
                  </Typography>
                  {infoLogin?.staffId && (
                    <Box className={classes.staffIdChip}>
                      MNV: {infoLogin.staffId}
                    </Box>
                  )}
                  {infoLogin?.email && (
                    <Typography className={classes.userEmailText} noWrap>
                      {infoLogin.email}
                    </Typography>
                  )}
                </Box>

                {statistic && statistic?.averageMark > 0.5 && (
                  <Box className={classes.medalWrapper}>
                    <img
                      src={
                        statistic.averageMark < 0.65
                          ? MEDAL_TB
                          : statistic.averageMark < 0.8
                          ? MEDAL_KHA
                          : statistic.averageMark < 1
                          ? MEDAL_GIOI
                          : MEDAL_THUKHOA
                      }
                      alt="MEDAL"
                      className={classes.medal}
                    />
                  </Box>
                )}
              </Box>

              {/* Action Button */}
              <Box className={classes.cardFooterAction}>
                <Button
                  endIcon={<ArrowRightAltIcon />}
                  className={classes.viewProfileBtn}
                  onClick={() => navigate("/profile")}
                >
                  {t("home.xemthem")}
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} lg={4} style={{ display: "flex", flexDirection: "column" }}>
          {/* lesson of month */}
          <Box className={classes.content__lessonOfMonth}>
            <Box className={classes.cardHeaderTitleRow}>
              <Box style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <MenuBookIcon style={{ color: "#D97706", fontSize: 24 }} />
                <Typography variant="h5" style={{ margin: 0, fontWeight: 800, fontSize: "0.9rem", color: "#0F172A", textTransform: "uppercase", letterSpacing: "0.03em" }}>
                  {t("home.sobaidahoctrongthang")}
                </Typography>
              </Box>
              <Chip
                label={`${(statistic && statistic.noLessionInMonth ? ((statistic.noLessionLearnedInMonth / statistic.noLessionInMonth) * 100) : 0).toFixed(1)}%`}
                size="small"
                style={{ backgroundColor: "#FEF3C7", color: "#D97706", fontWeight: 800, fontSize: 12, border: "1px solid #FDE68A" }}
              />
            </Box>

            <Box className={classes.content__lessonOfMonth__wrapper} style={{ paddingTop: 16, paddingBottom: 16 }}>
              <Box style={{ flexGrow: 1 }}>
                <Typography variant="subtitle2" className={classes.content__lessonOfMonth__point}>
                  {statistic?.noLessionLearnedInMonth || 0}
                  <Typography variant="subtitle2" component="span">
                    /{statistic?.noLessionInMonth || 0} bài
                  </Typography>
                </Typography>
                <Button
                  endIcon={<ArrowRightAltIcon />}
                  className={classes.content__lessonOfMonth__button}
                  onClick={() => navigate("/lesson-month")}
                >
                  {t("home.vaohoc")}
                </Button>
              </Box>

              <Box style={{ width: 110, height: 110, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <CircularProgressbarWithChildren
                  value={
                    (statistic &&
                      (statistic.noLessionLearnedInMonth / statistic.noLessionInMonth) * 100) ||
                    0
                  }
                  text={`${
                    statistic &&
                    (
                      (statistic.noLessionLearnedInMonth / statistic.noLessionInMonth) * 100 || 0
                    ).toFixed(1)
                  }%`}
                  strokeWidth={11}
                  styles={buildStyles({
                    strokeLinecap: "round",
                    textColor: "#92400E",
                    textSize: "15px",
                    pathColor: "#D97706",
                    trailColor: "#FEF3C7",
                  })}
                >
                  <RadialSeparators
                    count={12}
                    style={{
                      background: "#fff",
                      width: "2px",
                      height: `${14}%`,
                    }}
                  />
                </CircularProgressbarWithChildren>
              </Box>
            </Box>

            <Box className={classes.cardFooterNote}>
              <Typography variant="subtitle2" className={classes.content__lessonOfMonth__text} style={{ padding: 0, textAlign: "left", display: "flex", alignItems: "center" }}>
                <InfoIcon style={{ fontSize: 16, color: "#D97706", marginRight: 6 }} /> {t("home.note.month")}
              </Typography>
            </Box>
          </Box>
        </Grid>
        {/* statistic  */}
        {!isMobile && (
          <Grid item xs={12} sm={12} lg={4} style={{ display: "flex", flexDirection: "column" }}>
            <Statistics statistic={statistic} />
          </Grid>
        )}

        <Grid item xs={12} sm={12} lg={5}>
          <Box className={classes.content__lessonOfYear}>
            <Box className={classes.cardHeaderTitleRow}>
              <Box style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <SchoolIcon style={{ color: "#4F46E5", fontSize: 24 }} />
                <Typography variant="h5" style={{ margin: 0, fontWeight: 800, fontSize: "0.9rem", color: "#0F172A", textTransform: "uppercase", letterSpacing: "0.03em" }}>
                  {t("home.sobaidahoctrongnam")}
                </Typography>
              </Box>
              <Chip
                label={`${(statistic && statistic.noLessionInYear ? ((statistic.noLessionLearnedInYear / statistic.noLessionInYear) * 100) : 0).toFixed(1)}%`}
                size="small"
                style={{ backgroundColor: "#EEF2FF", color: "#4F46E5", fontWeight: 800, fontSize: 12, border: "1px solid #C7D2FE" }}
              />
            </Box>

            <Box className={classes.content__lessonOfMonth__wrapper} style={{ paddingTop: 16, paddingBottom: 16 }}>
              <Box style={{ flexGrow: 1 }}>
                <Typography variant="subtitle2" className={classes.content__lessonOfYear__point}>
                  {statistic?.noLessionLearnedInYear || 0}
                  <Typography variant="subtitle2" component="span">
                    /{statistic?.noLessionInYear || 0} bài
                  </Typography>
                </Typography>
                <Button
                  endIcon={<ArrowRightAltIcon />}
                  className={classes.content__lessonOfYear__button}
                  onClick={() => navigate("/lesson-month")}
                >
                  {t("button.detail")}
                </Button>
              </Box>

              <Box style={{ width: 110, height: 110, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <CircularProgressbarWithChildren
                  value={
                    (statistic &&
                      (statistic.noLessionLearnedInYear / statistic.noLessionInYear) * 100) ||
                    0
                  }
                  text={`${
                    statistic &&
                    (
                      (statistic.noLessionLearnedInYear / statistic.noLessionInYear) * 100 || 0
                    ).toFixed(1)
                  }%`}
                  strokeWidth={11}
                  styles={buildStyles({
                    strokeLinecap: "round",
                    textColor: "#312E81",
                    textSize: "15px",
                    pathColor: "#4F46E5",
                    trailColor: "#EEF2FF",
                  })}
                >
                  <RadialSeparators
                    count={12}
                    style={{
                      background: "#fff",
                      width: "2px",
                      height: `${14}%`,
                    }}
                  />
                </CircularProgressbarWithChildren>
              </Box>
            </Box>

            <Box className={classes.cardFooterNote}>
              <Typography variant="subtitle2" className={classes.content__lessonOfMonth__text} style={{ padding: 0, textAlign: "left", display: "flex", alignItems: "center" }}>
                <InfoIcon style={{ fontSize: 16, color: "#4F46E5", marginRight: 6 }} /> {t("home.note.year")}
              </Typography>
            </Box>
          </Box>
        </Grid>

        {isMobile && (
          <Grid item xs={12}>
            <Statistics statistic={statistic} />
          </Grid>
        )}
        {/* Ranking  */}
        <Grid item xs={12} sm={12} lg={7}>
          <Box className={classes.rankingCard}>
            <Grid container spacing={2} style={{ height: "100%", margin: 0, width: "100%" }}>
              <Grid item xs={12} sm={4} style={{ display: "flex" }}>
                <Box className={classes.ranking__content}>
                  <Box>
                    <Typography variant="h5" className={classes.rankingTitle}>
                      {t("home.thanhtichcanhan")}
                    </Typography>

                    <Box className={classes.ranking__content__detail}>
                      <Typography className={classes.rankLabelText}>
                        HẠNG HIỆN TẠI
                      </Typography>
                      <Typography className={classes.highlightRankNum}>
                        {statistic?.currentRank === null ? "-" : statistic?.currentRank}
                      </Typography>
                      <Typography className={classes.totalStudentsText}>
                        Trên tổng số {statistic?.totalStudents || 0} học viên
                      </Typography>
                    </Box>
                  </Box>

                  <Typography variant="body2" className={classes.rankSubtext}>
                    {t("home.cogangphathuy")}
                  </Typography>
                </Box>
              </Grid>

              {/* Chart */}
              <Grid item xs={12} sm={8}>
                <ChartRanking ranking={statistic?.ranks} />
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* Table calendar */}
      </Grid>
      <Box mt={2} mb={2}>
        <TableCalendar />
      </Box>
    </Box>
  );
}
